'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tag = exports.section = exports.category = exports.article = undefined;

var _normalizr = require('normalizr');

var article = new _normalizr.Schema('articles');
var author = new _normalizr.Schema('authors');
var category = new _normalizr.Schema('categories');
var section = new _normalizr.Schema('section');
var tag = new _normalizr.Schema('tags');
var topic = new _normalizr.Schema('topics');

article.define({
  categories: (0, _normalizr.arrayOf)(category),
  designers: (0, _normalizr.arrayOf)(author),
  engineers: (0, _normalizr.arrayOf)(author),
  photographers: (0, _normalizr.arrayOf)(author),
  sections: (0, _normalizr.arrayOf)(section),
  tags: (0, _normalizr.arrayOf)(tag),
  topics: topic,
  writers: (0, _normalizr.arrayOf)(author)
});

exports.article = article;
exports.category = category;
exports.section = section;
exports.tag = tag;


/*****************
 ** WEBPACK FOOTER
 ** ./src/schemas/index.js
 ** module id = 839
 ** module chunks = 0
 **/